<script>
import {ref, watch} from "vue";
import {useRoute} from "vue-router";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import BuyBox from "@/components/assetComponents/BuyBox.vue";
import {useStore} from "vuex";

export default {
  name: "StorePage",
  components: {BuyBox, LoadingPage},

  setup() {

    let store = useStore()

    let orders = store.state.order
    let buy_box = ref(false)
    if (orders.products.length > 0) buy_box.value = true

    let loading = ref(false)
    let sid = useRoute().params.sid
    let shopname = useRoute().params.shopname
    let header_pic = ref(null)
    let profile_pic = ref(null)

    let filter = store.state.filter.storePage
    let search = ref('')
    let products = []

    let res_search = ref([])

    watch(() => search.value, () => {

      let i = {
        sid: sid,
        shopname: shopname,
        search: search.value
      }
      if (search.value.length > 0) {
        store.commit('set_storePage_filter', i)
      } else {
        store.commit('set_storePage_filter', 'delete')
      }
      res_search.value = []
      products.forEach((item) => {

        if (item.name.includes(search.value) || item.brand.includes(search.value)) res_search.value.push(item)

      })

    })


    function products_store() {

      loading.value = true
      FreeWorld.Heisenberg({action: 'shop', sid: sid}, 'info').then((res) => {

        loading.value = false
        res_search.value = res.data
        products = res.data
        if (products[0]) {
          header_pic.value = products[0].header_pic;
          profile_pic.value = products[0].profile_pic
        }
        console.log(filter)

        if (filter !== null && filter.sid == sid) {
          search.value = filter.search
          open_search()
        } else {
          store.commit('set_storePage_filter', 'delete')
        }

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, products_store)
      })

    }

    products_store()

    function open_search() {

      let input_search = document.getElementById('input_search')

      if (input_search.style.width !== '15rem') {
        input_search.style.width = '15rem'
      } else {
        input_search.style.width = '2.6rem'
      }

    }

    return {
      open_search,
      loading,
      res_search,
      search,
      buy_box,
      shopname,
      header_pic,
      profile_pic,
    }
  }
}
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" class="bg-main">

    <div class="header_custom max_width shadow-custom bg-white">

      <div class="animated-background img_header">
        <img class="w-100 h-100" :src="header_pic" alt="">
      </div>

      <div class="d-flex justify-content-between align-items-start position-relative h-100 p-4">
        <div class="position-relative">
          <input v-model="search" id="input_search"
                 class="input_search font-5 text-center rounded-pill p-2 position-absolute bg-white shadow-custom"
                 placeholder="جستجو" type="text">
          <img @click="open_search" class="icon-size-4 position-relative" src="../assets/img/icon_search_bgLight.svg"
               alt="">
        </div>

        <div class="d-flex justify-content-end align-items-center w-80">
          <p dir="rtl" class="font-color p-2 rounded-pill bg-white font-4 font-bold me-2">{{ shopname }}</p>
          <img onclick="window.history.back()" class="svg-arrow" src="../assets/img/aroowback-white.svg" alt="">
        </div>

        <div class="img_profile animated-background position-absolute me-5">
          <img v-if="profile_pic === null" src="../assets/img/defult-profile.svg" alt="" class="img_profile">
          <img v-else :src="profile_pic" alt="" class="img_profile">
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>

    <div style="height: calc(100vh - 19rem);" class="p-body overflow-y-scroll mt-3">

      <div v-for="item in res_search" :key="item.id"
           class="animate__animated animate__fadeInRight bg-white mb-3 shadow-custom p-2 rounded-4 d-flex justify-content-between">
        <router-link :to="{name:'DetailsProducts',params:{pid:item.pid}}"
                     class="text-decoration-none text-black w-60 ml-3 d-flex flex-column justify-content-around">
          <div class="overflow-hidden">
            <p class="font-bold font-5" :class="{'txtoverflow': item.name.length > 30}">{{ item.name }}</p>
          </div>

          <div class="overflow-hidden">
            <p class="font-5 my-2" :class="{'txtoverflow': item.brand.length > 20}">از برند {{ item.brand }}</p>
          </div>

          <div class="d-flex align-items-center">
            <p :class="item.price !== item.price_off ? 'text-decoration-line-through font-5':'font-4 font-bold' "
               class="d-flex">
              <span class="">{{ item.price.toLocaleString() }}</span>
              &nbsp;
              <span v-if="item.price === item.price_off" class="font-5">تومان</span>
            </p>
            <p v-if="item.price !== item.price_off" class="font-4 d-flex font-color font-bold mr-3">
              <span class="">{{ item.price_off.toLocaleString() }}</span>
              <span class="mr-1 font-5">تومان</span>
            </p>
          </div>

          <div class="div_hr my-2"></div>

          <div class="d-flex align-items-center justify-content-between">

            <div class="d-flex align-items-center">
              <img class="icon_shop ml-2" src="../assets/img/store_light.svg" alt="">
              <p class="font-5">{{ item.shops_count }} فروشگاه</p>
            </div>

            <v-btn class="bg-color-light h-100 py-1 px-2 font-5 rounded-pill shadow-custom">مشاهده جزییات</v-btn>
          </div>

        </router-link>

        <div class="img_prod rounded-3 animated-background">
          <img class="w-100 h-100 rounded-3" :src="item.pic" alt="">
        </div>
      </div>

    </div>

    <router-link :to="{name:'CartPage'}">
      <BuyBox v-if="buy_box"></BuyBox>
    </router-link>

  </div>

</template>


<style scoped>
.header_custom {
  position: fixed;
  top: 0;
  width: 100%;
  direction: ltr;
  height: 15rem;
}

.img_profile {
  width: 6rem;
  height: 6rem;
  border-radius: 50%;
  bottom: -19%;
  right: 0;
}

.img_header {
  position: absolute;
  height: 15rem;
  width: 100%;
  filter: brightness(0.5);
}

@media (min-width: 900px) {
  .img_prod {
    width: 26% !important;
    height: 12rem !important;
  }
}
.img_prod {
  width: 40%;
  height: 11.3rem;
}
.div_hr {
  width: 100%;
  height: 1px;
  border: rgba(43, 48, 53, 0.47) dashed 1px;
}
.icon_shop {
  width: 1.5rem;
}
.input_search {
  left: -1px;
  top: 50%;
  transform: translate(0, -50%);
  width: 2.6rem;
  transition: .5s;
}

</style>